import React, { useState, useCallback } from 'react';

import { format, subDays } from 'date-fns';
import * as Yup from 'yup';

import { Report } from '~/components';
import { DateTime, RadioGroup } from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';
import { validation } from '~/helpers/yupValidations';

export default function DVECDanificadoParado() {
  const [open, setOpen] = useState(true);
  const [type, setType] = useState('D');

  const dateTime = {
    start: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
    end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
  };

  const optionsType = [
    {
      label: t('s.relatorio.dvecdanificadoparado.tipodanificadoparado'),
      value: 'D',
    },
    { label: t('s.relatorio.dvecdanificadoparado.tipohistorico'), value: 'H' },
  ];

  const output = [
    { label: 'PDF', value: 'pdf' },
    { label: 'Excel', value: 'excel' },
  ];

  const company = [
    {
      id: 'idempresaveiculo',
      label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
      filter: { type: 'text' },
    },
    {
      id: 'nomeempresaveiculo',
      label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
      filter: { type: 'text' },
    },
  ];

  const vehicle = [
    {
      id: 'idveiculo',
      label: t('s.configuracao.comboio.idveiculo'),
      filter: { type: 'text' },
    },
    {
      id: 'placaveiculo',
      label: t('s.cadastro.veiculo.placaveiculo'),
      filter: { type: 'text' },
    },
    {
      id: 'nomemodeloveiculo',
      label: t('s.menu.cadastro.veiculo.modelo'),
      filter: { type: 'text' },
    },
  ];

  const handleValidateForm = useCallback(
    async (data) => {
      try {
        const schema = Yup.object().shape({
          datahorainicial:
            type === 'H'
              ? Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          datahorafinal:
            type === 'H'
              ? Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
        });

        await validation(schema, data);
      } catch (err) {
        const form = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });

          // eslint-disable-next-line no-throw-literal
          throw { form };
        }
      }
    },
    [type]
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.dvecdanificadoparado')}
      relatorio="dvecdanificadoparado"
      validate={handleValidateForm}
      initials={{
        tipo: type,
        formato: 'pdf',
        datahorainicial: dateTime.start,
        datahorafinal: dateTime.end,
      }}
    >
      <RadioGroup
        name="tipo"
        label={t('s.cadastro.veiculo.tipoveiculo')}
        options={optionsType}
        serialize={(value) => value}
        getValue={(value) => setType(value)}
        row
      />

      {type === 'H' && (
        <div
          style={{
            marginTop: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
          }}
        >
          <DateTime
            label={t('s.geral.opcoes.datahorainicial')}
            name="datahorainicial"
            time
          />

          <DateTime
            label={t('s.geral.opcoes.datahorafinal')}
            name="datahorafinal"
            time
          />

          <PesquisaTabela
            name="idempresaveiculo"
            label={t('s.menu.cadastro.veiculo.empresa')}
            primary="idempresaveiculo"
            secondary="nomeempresaveiculo"
            url="empresasveiculos"
            header={company}
          />

          <PesquisaTabela
            name="idveiculo"
            label={t('s.menu.cadastro.veiculo')}
            primary="idveiculo"
            secondary="nomemodeloveiculo"
            url="veiculos"
            header={vehicle}
          />
        </div>
      )}

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={output}
        serialize={(value) => value}
        row
      />
    </Report>
  );
}
